(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxPrinterAdvancedSettings(
    Utils, $http, toastr, $filter
  ) {
    return {
      restrict: 'EA',
      scope: {
        me: '=me',
        isThisResourceMine: '=isThisResourceMine',
        context: '=context',
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/printerProperties/printerSettings/printerAdvancedSettings/printerAdvancedSettings.template.html',
      link: function(scope) {

        scope.privatePrinter = angular.copy(scope.context.printer.info);

        scope.pdlsMap = {
          PCL5: {
            selected: false
          },
          PCLXL: {
            selected: false
          },
          POSTSCRIPT: {
            selected: false
          },
          PDF: {
            selected: false
          },
          XPS: {
            selected: false
          },
          UFRII: {
            selected: false
          }
        };

        (function() {
          setPdlsMapping();
        })();

        function setPdlsMapping () {
          for (var i = 0; i < scope.context.printer.info.pdls.length; i++) {
            scope.pdlsMap[scope.context.printer.info.pdls[i]].selected = true;
          }
        }

        scope.saveSettings = function () {

          var patch = Utils.getObjectsDifferencesForPatching(scope.context.printer.info, scope.privatePrinter);

          if (!angular.equals(scope.privatePrinter.pdls, pdlsAsEnums(scope.pdlsMap))) {
            var patchPdls = {
              op: 'replace',
              path: '/pdls',
              value: pdlsAsEnums(scope.pdlsMap)
            }
            patch.push(patchPdls)
          }

          var url = scope.context.printer.info._links.self.href;

          $http.patch(url, patch).then(function(response) {
            toastr.success($filter('translate')('ChangesSaved'))
          }).catch(function(error) {
            toastr.error($filter('translate')('ERROR'))
          });

          scope.callback();
        }



        function pdlsAsEnums (pdls) {
          var pdlsEnums = [];

          for (var key in pdls) {
            if (pdls[key].selected === true) {
              pdlsEnums.push(key);
            }
          }

          return pdlsEnums;
        }

        scope.$on('$destroy', function() {
        });

      }
    };
  }

  pxPrinterAdvancedSettings.$inject = ['Utils', '$http', 'toastr', '$filter'];

  angular
    .module('printix-admin')
    .directive('pxPrinterAdvancedSettings', pxPrinterAdvancedSettings);

})();
